import React, { useRef, useState } from "react";
import { Box, Menu, Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { FilterList } from "@mui/icons-material";
import _ from "lodash";
import LegalbirdRefinementList from "./LegalbirdRefinementList";
import Overlay from "../../Overlay/Overlay";
import LegalbirdClearRefinements from "./LegalbirdClearRefinements";
import { boardRefinementsStyle } from "./boardRefinementsStyle";
import { AlgoliaRefinement } from "../../../types/Algolia/AlgoliaRefinement";

type BoardRefinementsProps = {
  refinements: AlgoliaRefinement[];
  filterHeadline?: string;
};
const BoardRefinements = (props: BoardRefinementsProps) => {
  const { refinements, filterHeadline = "Filtern nach" } = props;
  const anchor = useRef<HTMLDivElement>(null);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);

  return (
    <>
      {filterMenuOpen && <Overlay />}
      <Tooltip title={"Filter"}>
        <IconButton sx={boardRefinementsStyle.menuButton} onClick={() => setFilterMenuOpen(true)} size="large">
          <FilterList sx={boardRefinementsStyle.filterIcon} />
        </IconButton>
      </Tooltip>
      <div ref={anchor} />
      <Menu
        sx={boardRefinementsStyle.menu}
        open={filterMenuOpen}
        anchorEl={anchor.current}
        onClose={() => setFilterMenuOpen(false)}
        keepMounted={true}
      >
        <Box sx={boardRefinementsStyle.filterHeadline}>{filterHeadline}</Box>
        {_.map(refinements, (refinement) => {
          return (
            <LegalbirdRefinementList
              key={refinement.attribute.name}
              refinement={refinement}
            />
          );
        })}
        <LegalbirdClearRefinements />
      </Menu>
    </>
  );
};

export default BoardRefinements;
